// @flow

import React, { Component } from 'react';
import noop from 'lodash/noop';
import glamorous, { Div } from 'glamorous';
import t from 'app/utils/translate';
import { PlayChip } from 'app/components/styled/currencyIcons';
import Grid from '../layout/Grid';
import GridCol from '../layout/GridCol';
import Button from '../commons/Button';
import FormValidationMessage from '../commons/FormValidationMessage';

type Props = {
  errorMessages?: Array<Object>,
  id: number,
  isPurchasing: boolean,
  image: *,
  name: string,
  onBuy: () => void,
  onCancel?: () => void,
  price: number,
};

type State = {
  confirming: boolean,
};

const ConfirmContainer = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

const ButtonContainer = glamorous.div(props => ({
  paddingTop: props.theme.spacing.default,
  width: '100%',
}));

const ConfirmButton = glamorous(Button)(props => ({
  marginBottom: props.theme.spacing.small,
}));

const Name = glamorous.div(({ theme }) => ({
  fontSize: theme.fontSize.medium,
  fontWeight: theme.fontWeight.demiBold,
}));

const Bold = glamorous.span(({ theme }) => ({
  fontWeight: theme.fontWeight.demiBold,
}));

class GiftDetail extends Component<Props, State> {
  props: Props;
  state: State = {
    confirming: false,
  };

  static defaultProps = {
    cost: null,
    errorMessages: undefined,
    details: '',
    onCancel: noop,
  };

  render() {
    const { errorMessages, id, isPurchasing, image, name, onBuy, onCancel, price } = this.props;
    const { confirming } = this.state;
    return (
      <Grid>
        <GridCol width="one-half">
          <img
            alt={name}
            src={image.res1x}
            srcSet={`${image.res1x} 1x, ${image.res2x} 2x`}
            width={200}
            height="auto"
          />
        </GridCol>
        <GridCol width="one-half">
          {confirming ? (
            <ConfirmContainer>
              <div>
                <span>
                  Are you sure you want to redeem a <Bold>{name}</Bold> voucher for{' '}
                </span>
                <PlayChip />
                <Bold>{price}</Bold>
                <span>?</span>
              </div>
              <ButtonContainer>
                <ConfirmButton
                  block
                  size="large"
                  kind="primary"
                  disabled={isPurchasing}
                  onClick={() => {
                    onBuy(id);
                  }}
                >
                  {isPurchasing ? 'Purchasing' : 'Confirm'}
                </ConfirmButton>
                <Button
                  block
                  size="default"
                  kind="cancel"
                  onClick={() => {
                    // $FlowIssue - defaultProps
                    onCancel();
                    this.setState({ confirming: false });
                  }}
                >
                  {t('Cancel')}
                </Button>
              </ButtonContainer>
            </ConfirmContainer>
          ) : (
            <div>
              <Name>{name}</Name>
              <Div paddingBottom="10">
                <span>Cost: </span>
                <PlayChip />
                <Bold>{price}</Bold>
              </Div>
              <Button
                block
                size="large"
                kind="primary"
                onClick={() => {
                  this.setState({ confirming: true });
                }}
              >
                {t('Buy Now')}
              </Button>
            </div>
          )}
          {errorMessages && <FormValidationMessage message={errorMessages} />}
        </GridCol>
      </Grid>
    );
  }
}

export default GiftDetail;
